/* eslint-disable new-cap */
import { get } from 'lodash';

import {
  OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL,
  CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL,
  FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED,
  CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  content: null,
  isOpen: false,
};

export default createReducer(initialState, {
  [OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL](state, { payload }) {
    return {
      ...state,
      isOpen: true,
      content: get(state, `package_${payload.productId}_${payload.packageId}`),
    };
  },
  [CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL](state) {
    return {
      ...state,
      isOpen: false,
      content: null,
    };
  },
  [FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED](state, { payload }) {
    return {
      ...state,
      [`package_${payload.package.productId}_${payload.package.id}`]: payload.package,
    };
  },
  [CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL]() {
    return initialState;
  },
});
